import ModalContainer from '../../containers/ModalContainer'
import ModalSimple from './components/ModalSimple'
export { ModalContainer, ModalSimple }
export default ModalContainer
